import { Button } from 'components';
import MessageItem from 'components/Chat/MessageItem';
import { YARIKANO_CHAT_CTA_LABEL } from '../../constants';
import {
  EYarikanoChatLogKind,
  EYarikanoCtaPlacement,
  EYarikanoQuestionId,
  TMember,
  TYarikanoChatLogEntry,
} from 'types';
import {
  getLogEntryDisplayText,
  isQuestionLogKind,
  noop,
  shouldShowOperatorAvatar,
  toPseudoMessage,
} from './helpers';

type Props = {
  entry: TYarikanoChatLogEntry;
  index: number;
  log: TYarikanoChatLogEntry[];
  operatorMember: TMember;
  onCtaClick: (
    questionId: EYarikanoQuestionId,
    placement: EYarikanoCtaPlacement,
  ) => void;
};

const YarikanoChatLogEntry = ({
  entry,
  index,
  log,
  operatorMember,
  onCtaClick,
}: Props) => {
  if (entry.kind === EYarikanoChatLogKind.ANSWER_CTA) {
    return (
      <div
        className="flex justify-start pl-12 pr-4"
        data-testid={`yarikano-answer-cta-${entry.questionId}`}
      >
        <Button
          bold
          onClick={() => onCtaClick(entry.questionId, EYarikanoCtaPlacement.ANSWER)}
          textSize="text-sm"
          rounded="rounded-full"
          iconRight="arrowRight"
          iconColor="white"
          className="ml-3"
          padding="py-3 px-4"
        >
          {YARIKANO_CHAT_CTA_LABEL}
        </Button>
      </div>
    );
  }

  const isQuestion = isQuestionLogKind(entry.kind);

  return (
    <div className="shrink-0">
      <MessageItem
        message={toPseudoMessage(entry, isQuestion)}
        displayText={getLogEntryDisplayText(entry)}
        isEdited={false}
        isMyMessage={isQuestion}
        isAdminMessage={false}
        showAvatar={shouldShowOperatorAvatar(entry, index, log)}
        user={isQuestion ? undefined : operatorMember}
        onClickAvatar={noop}
      />
    </div>
  );
};

export default YarikanoChatLogEntry;
